import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { itHelpDeskData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function ITHelpDeskPage() {
    return <SolutionTemplate {...itHelpDeskData} />;
}
